/** ******** 数据管理  ********* */
// ========== 普查客户申请
export const getSurveyApplyList = {
  url: '/admin/cust/survey/apply/list',
  method: 'post'
};

export const getAreaListData = {
  url: '/admin/common/getAllAreaInfo.json',
  method: 'get'
};

export const getCommonCustomList = {
  url: '/admin/common/getCustomerType.json',
  method: 'get'
};

// 审核普查客户申请
export const auditSurveyApply = {
  url: '/admin/cust/survey/apply/edit',
  method: 'post'
};

export const batchAuditPass = {
  url: '/admin/cust/survey/apply/batch',
  method: 'post'
};

// ======== 普查客户数据
export const getSurveyDataList = {
  url: '/admin/customerSurvey/getCustomerListAdmin.json',
  method: 'get'
};

export const saveSurveyData = {
  url: '/admin/customerSurvey/adminSaveOrUpdateCustSurvey.json',
  method: 'post'
};

export const importSurveyData = {
  url: '/admin/customerSurvey/importCustomerSurvey'
};
// 普查客户相似客户列表
export const getApplySimilarCust = {
  url: '/admin/cust/survey/apply/similar',
  method: 'get'
}
export const matchApplySimilarCust = {
  url: '/admin/cust/survey/apply/match',
  method: 'post',
  config: {
    headers: { 'Content-Type': 'multipart/form-data' }
  }
}
// 地址识别
export const addressRecognition = {
  url: '/mobile/v2/salesman/addressRecognition',
  method: 'post',
  config: {
    headers: { 'Content-Type': 'multipart/form-data' }
  }
}